<template>
  <div v-loading="isLoading">
    <el-row :gutter="15">
      <el-col :span="24">
        <el-form size="small">
          <el-row :gutter="15">
            <el-col :span="12">
              <DateForm ref="dateForm" />
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Customer"
              >
                <AccountAutoComplete
                  ref="accountAutoComplete"
                  v-model="account"
                  @loadCarrier="loadCarrier"
                />
                <el-checkbox
                  v-model="form.showChildrenAccts"
                  label="Include Child Accounts"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-button
                type="primary"
                size="small"
                class="float-right"
                @click.native="downloadCSV()"
              >
                Generate Report
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="isShowPreview"
      title="Distance Matrix"
      width="70vw"
      top="5vh"
      :close-on-click-modal="false"
      @closed="isShowPreview = false"
    >
      <h2>Due to the processing time of this report it will be emailed to you</h2>
      <p>The status can be checked from the jobs menu in the top right corner</p>
    </el-dialog>
  </div>
</template>

<script>
import DateForm from '@/components/Application/Reports/DateForm'
import AccountAutoComplete from '@/components/Application/Reports/AccountAutoComplete'
import Request from '@/plugins/sdk/Request'

export default {
  components: {
    DateForm,
    AccountAutoComplete
  },
  data () {
    return {
      pageTitle: 'Distance Matrix',
      breadcrumb: {
        name: 'Distance Matrix',
        route: { name: 'reports-freight-distance-matrix' }
      },
      account: {},
      carrierSettings: [],
      form: {
        dateFrom: null,
        dateTo: null,
        accountId: null,
        showChildrenAccts: false
      },
      isShowPreview: false,
      isLoading: false
    }
  },
  methods: {
    setDate (date) {
      this.form.dateFrom = this.$moment(date[0]).format('YYYY-MM-DD HH:mm:ss')
      this.form.dateTo = this.$moment(date[1]).format('YYYY-MM-DD HH:mm:ss')
    },
    loadCarrier () {
      this.form.accountId = this.$refs.accountAutoComplete.getAccountIds()
    },
    async fetchData (configuration) {
      const response = await fetch(await Object.assign(new Request(), {
        _pathname: `/reports/${configuration.report}`,
        filters: configuration.params
      }).build())

      if (response.ok) {
        this.isLoading = false
        this.isShowPreview = true
      } else {
        this.isLoading = false
        this.$message({
          showClose: true,
          message: 'Unable to process report request',
          type: 'error'
        })
      }
    },
    downloadCSV () {
      this.isLoading = true
      this.$refs.dateForm.$refs.form
        .validate(async (valid) => {
          if (valid) {
            this.setDate(this.$refs.dateForm.form.value)
            await this.fetchData({
              report: 'DistanceMatrix',
              params: this.form
            })
          }
        })
    }
  }
}
</script>
